import { React, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Grid, TextField, useTheme } from "@material-ui/core";
import axios from "axios";
import { tokens } from "../../../styles/theme";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import Controls from "../global/controls/Controls";
import { useEffect } from "react";
import { useForm } from "./useForm";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const ResetPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [resetpassword, setResetPassword] = useState({
    code: "",
    password: "",
    password_confirmation: "",
    codeError: "",
    passwordError: "",
    passwordConfirmationError: "",
  });
  const initialFValues = {
    code: "",
    password: "",
    password_confirmation: "",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    
    if ("code" in fieldValues) {
      if (fieldValues.code == "") {
        temp.code = "الكود مطلوب";
      } else {
        temp.code = "";
      }
    }
 
  
    // if ("password" in fieldValues) {
    //   temp.password = fieldValues.password ? "" : "كلمة السر مطلوبة";
    //   if (fieldValues.password.length < 8) {
    //     temp.password = "يجب أن تكون كلمة السر على الأقل 8 أحرف";
    //   }
    //   else {
    //     temp.password = "";
    //   }
    // }

    // if ("password_confirmation" in fieldValues) {
    //   if (fieldValues.password_confirmation == "") {
    //     temp.password_confirmation = "تأكيد كلمة المرور";
    //   } else if (fieldValues.password_confirmation !== loginInput.password) {
    //     temp.password_confirmation = "يجب أن يكون مطابق لكلمة السر";
    //   } else {
    //     temp.password_confirmation = "";
    //   }
    // }
  
    setErrors({
      ...temp,
    });
  
    if (fieldValues === loginInput) {
      return Object.values(temp).every((x) => x === "");
    }
  };
  const handeleInput = (e) => {
    e.persist();
    setLogin({
      ...loginInput,
      [e.target.name]: e.target.value,
    });
  };
 
  const loginSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      const data = {
        code: loginInput.code,
        password: loginInput.password,
        password_confirmation: loginInput.password_confirmation,
      };
      try {
        const res = await axios.post(`${BaseUrl}/api/mobile/password/reset`, data, {
          withCredentials: true,
        });
  
        if (res.data.status == true) {
          sweetalert("Password has been successfully changed");
          navigate("/");
        } else if (res.data.status === "error") {
          sweetalert("تم ادخال كود خاطئ", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        }
      } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 500) {
            sweetalert(error.response.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
        // Handle error appropriately
      } finally {
        setLoading(false);
      }
    }
  };
  const { loginInput, setLogin, errors, setErrors } = useForm(
    initialFValues,
    true,
    validate
  );
  useEffect(() => {
    if (loading === true && !validate()) {
      setTimeout(() => {
        // After the timeout, reset the loading state
        setLoading(false);
        // Your other logic here
      }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);

  return (
    <div>
      <form className="form-group" onSubmit={loginSubmit}>
        <Grid container style={{ minHeight: "100vh" }}>
          <Grid item className="home-item" xs={12} sm={6}>
            <h1 style={{ textAlign: "center" }}>ليرتنا كاش</h1>
            <p>
              {" "}
              صمم هذا التطبيق ليكون أداة مساعدة لمراكز تعبئة الرصيد في سوريا،
              فهو مخصص لتحويل الوحدات و تسديد الفواتير لشبكتي سيرياتل و ام تي ان
              بسهولة بالغة، يقدم إمكانية إدارة موزعين الجملة و مراكز الخدمة في
              مختلف المحافظات و المناطق مع إمكانية حفظ الزبائن في قاعدة البيانات
              و بالتالي يمكن التحويل للعميل من خلال اختيار اسمه وتحديد كمية
              الوحدات فقط، كما أنه يمكن حفظ نسخة من التقارير بأنواعها المختلفة
              ضمن سجل خاص{" "}
            </p>
            <img src="hom.svg" alt="login-img" />
          </Grid>
          <Grid
            container
            item
            alignItems="center"
            direction="column"
            justify="center"
            xs={12}
            sm={6}
            style={{ padding: 10 }}
          >
            <div>
              <h2 className="title-home">إعادة تعيين كلمة المرور</h2>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
                 <Controls.Input
                label="الكود"
                fullWidth
                type="text"
                margin="normal"
                name="code"
                onChange={handeleInput}
                className="form-control"
                error={errors.code}
              />
                 <Controls.Input
                 label="كلمة المرور"
                type="password"
                name="password"
                onChange={handeleInput}
                className="form-control"
                error={errors.password}
              />
                 <Controls.Input
            
                label="تأكيد كلمة المرور"
                type="password"
                name="password_confirmation"
                onChange={handeleInput}
                className="form-control"
                error={errors.password_confirmation}
              />
  
              {loading === true ? (
                <>
                  <Controls.Button
                    text=<div class="spinner center">
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                    </div>
                    variant="contained"
                    className="btn-submit resend-code"
                  ></Controls.Button>
                </>
              ) : (
                <Controls.Button
                  type="submit"
                  text="إرسال"
                  variant="contained"
                  className="btn-submit"
                ></Controls.Button>
              )}
            </div>
          <Link
                style={{ textAlign: "left" }}
                to={{
                  pathname: "/resend-code",

                  state: { fromDashboard: true },
                }}
              >
                إعادة طلب رمز التحقق
              </Link>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
